(() => {
  const panel = document.querySelector('[data-cc-display]');
  if (!panel) return;
  const root = document.documentElement;
  const background = panel.querySelector('[data-cc-background]');
  const size = panel.querySelector('[data-cc-text-size]');
  const motion = panel.querySelector('[data-cc-motion]');
  const status = panel.querySelector('[data-cc-status]');
  const key = 'cc-display-preferences-v1';
  const allowedBackgrounds = ['default', 'cream', 'peach'];
  const allowedSizes = ['1', '1.25', '1.5', '2'];
  function apply(value) {
    background.value = allowedBackgrounds.includes(value.background) ? value.background : 'default';
    size.value = allowedSizes.includes(String(value.size)) ? String(value.size) : '1';
    motion.checked = value.motion === true;
    root.dataset.ccBackground = background.value;
    root.dataset.ccTextSize = size.value;
    root.style.setProperty('--cc-text-scale', size.value);
    root.dataset.ccMotion = motion.checked ? 'reduce' : 'default';
    if (motion.checked) document.querySelectorAll('video').forEach(video => video.pause());
    document.dispatchEvent(new CustomEvent('cc:display-change'));
  }
  let initial = {};
  try { initial = JSON.parse(sessionStorage.getItem(key)) || {}; } catch {}
  apply(initial);
  panel.hidden = false;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cc-open-display]');
    if (!trigger) return;
    event.preventDefault();
    const drawer = trigger.closest('menu-drawer, header-drawer');
    if (drawer?.mainDetailsToggle?.open) {
      const menuSummary = drawer.mainDetailsToggle.querySelector('summary');
      drawer.closeMenuDrawer(event, false);
      if (menuSummary) menuSummary.setAttribute('aria-expanded', 'false');
    }
    panel.querySelector('details').open = true;
    const summary = panel.querySelector('summary');
    requestAnimationFrame(() => {
      summary.focus({ preventScroll: true });
      summary.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
  });
  panel.addEventListener('change', () => {
    const value = { background: background.value, size: size.value, motion: motion.checked };
    apply(value);
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {}
    status.textContent = status.dataset.saved;
  });
  panel.querySelector('[data-cc-reset]').addEventListener('click', () => {
    apply({});
    try { sessionStorage.removeItem(key); } catch {}
    status.textContent = status.dataset.reset;
  });
})();
